// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useEffect, useState} from 'react';
import cn from 'classnames';
import {useLocation} from 'react-router';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import Icon_v from '../../img/icons/16/check.svg';
import Icon_events from '../../img/icons/24/color/events_and_ecommerce.svg';
import Icon_ddc from '../../img/icons/24/color/dedicated_dc.svg';
import Icon_shared_dc from '../../img/icons/24/color/shared_dc.svg';
import Icon_isp from '../../img/icons/24/color/isp.svg';
import Icon_isp_plus from '../../img/icons/24/color/isp_premium.svg';
import Icon_smart_resi from '../../img/icons/24/color/residential.svg';
import Icon_sneakers from '../../img/icons/24/color/sneakers.svg';
import Icon_events_resi from '../../img/icons/24/color/events_resi.svg';
import {Button, t_oculus_button_color} from '../../lib/button';
import {use_app_context} from '../../../../toolip/pub/lib/app_context';
import {product_pages} from '../products';
import {Proxy_type} from '../../../../hola/pub/ui/pro/cp/orders';
import styles from './products.module.less';
import {Input} from '../../../../hola/pub/lib/input';
import {Dynamic_heading, Title_header_select} from '../../../../shared/editor/title_header_select';
import {use_data_provider} from '../../../../hola/pub/lib/use_data_provider';
import {use_plans} from '../plans/plans';
import {generate_product_cards_data} from '../pricing/buy_cards';

export interface i_product {
  id?: string;
  icon: JSX.Element;
  title: string;
  description: string;
  btn_caption: string;
  btn_link: string;
  features?: string[];
  show_promo?: boolean;
}

interface i_product_card_props {
  product: i_product;
  btn_color: t_oculus_button_color;
  with_description?: boolean;
  with_bar?: boolean;
  with_features?: boolean;
}

export const Product_card = (props: i_product_card_props)=>{
    const {product, btn_color, with_description = true,
        with_bar = true, with_features = true} = props;
    const {theme} = useContext(Settings_context);
    return (
      <div className={cn(styles.product_card)}>
        <div className={styles.text}>
          {product.icon}
          <p className={cn(theme.p18, theme.bold, styles.title)}>
            {product.title}</p>
          {with_description && <p className={cn(theme.p14, styles.des)}>
            {product.description}</p>}
        </div>
        {with_bar && <div className={styles.bar}/>}
        <Button caption={product.btn_caption} size="m" color={btn_color}
          fit={false} to={product.btn_link} cls={styles.btn}/>
        {with_features && <div className={styles.features}>
          {product.features.map((feature, index)=>
            <p key={index} className={cn(theme.p12, theme.med,
              styles.feature)}><Icon_v /> {feature}</p>
          )}
        </div>}
      </div>
    );
};

interface i_product_props{
    title?: string;
    title_tag?: string;
}

interface i_product_editor_props {
    value: i_product_props;
    on_change: (v:i_product_props)=>void;
    on_cancel: ()=>void;
}

export const Products_editor = (props:i_product_editor_props)=>{
    const [state, set_state] = useState<i_product_props>(props.value || {});

    useEffect(()=>{
        set_state(props.value);
    }, [props.value]);
    return <div>
      <Input size={'sm'} label={'title (html)'} value={state.title || ''}
        on_change={v=>set_state({...state, title: v})}/>
      <Title_header_select value={state.title_tag} on_select={v=>
        set_state({...state, title_tag: v})}/>
      <br/>
      <Button caption={'Save'} size={'s'}
        on_click={()=>props.on_change(state)}/>
      <Button caption={'Cancel'} size={'s'} on_click={()=>props.on_cancel()}/>
    </div>;
};

const get_price = (product_cards_data, type, fallback)=>{
    const cards = product_cards_data[type]?.cards || [];
    if (!cards.length)
        return fallback;
    const minCard = cards.reduce((min, card)=>{
        const price = parseFloat(card.price.replace(/[^0-9.]/g, ''));
        const minPrice = parseFloat(min.price.replace(/[^0-9.]/g, ''));
        return price < minPrice ? card : min;
    });
    return `Starting at ${minCard.price}`;
};

const products_data = (show_promo:boolean, oculus_plans)=>{
  const product_cards_data: any =
    generate_product_cards_data(oculus_plans, show_promo);
  return [
    {
      icon: <Icon_shared_dc />,
      title: 'Shared Datacenter Proxies',
      description: 'Bypass Restrictions Effortlessly: Rotating home IPs '
        + 'provide unmatched anonymity',
      btn_caption: show_promo ? 'Free trial' : get_price(
        product_cards_data,
        Proxy_type.SDC,
        'Starting at $0.10/GB'),
      btn_link: product_pages[Proxy_type.SDC],
      features: ['CCPA & GDPR Compliant', '99.99% uptime', '100GBPS'],
    },
    {
      icon: <Icon_ddc />,
      title: 'Dedicated Datacenter Proxies',
      description: 'Robust Infrastructure for Your Needs: Exclusive '
        + 'Datacenter Proxies for Resilient and Efficient Operations.',
      btn_caption: get_price(
        product_cards_data,
        Proxy_type.DDC,
        'Starting at $0.50/IP'),
      btn_link: product_pages[Proxy_type.DDC],
      features: ['CCPA & GDPR Compliant', '99.99% uptime', '100GBPS'],
    },
    {
      icon: <Icon_isp />,
      title: 'ISP Proxies',
      description: 'Utilize our superior ISP proxies for enhanced data '
        + 'collection and gain a strategic edge',
      btn_caption: get_price(
        product_cards_data,
        Proxy_type.SHARED_ISP,
        'Starting at $0.50/GB'),
      btn_link: product_pages[Proxy_type.SHARED_ISP],
      features: ['Huge pool of IPs', 'Pricing that can\'t be beat',
        '99.99% uptime'],
    },
    {
      icon: <Icon_isp_plus />,
      title: 'ISP Premium Proxies',
      description: 'Extend Your Scraping Capabilities to Google Servers and '
        + 'Major Social Media Platforms.',
      btn_caption: get_price(
        product_cards_data,
        Proxy_type.ISPPREM,
        'Starting at $0.75/IP'),
      btn_link: product_pages[Proxy_type.ISPPREM],
      features: ['Scrape Google & Social Media', 'High quality US proxies',
        'Private IP (not shared)'],
    },
    {
      icon: <Icon_smart_resi />,
      title: 'Residential Scraper',
      description: 'Residential IPs from 150+ countries provided in '
        + 'read-only, compliance mode to scrape any website',
      btn_caption: get_price(
        product_cards_data,
        Proxy_type.RES,
        'Starting at $1/GB'),
      btn_link: product_pages[Proxy_type.RES],
      features: ['True Residential IPs', '195 countries',
        'Scrape any website'],
    },
    {
      icon: <Icon_events />,
      title: 'Events & E-commerce Proxies',
      description: 'Perfect for securing top spots at events and accessing'
        + ' e-commerce sites seamlessly.',
      btn_caption: get_price(
        product_cards_data,
        Proxy_type.EV_ISP,
        'Starting at $0.57/IP'),
      btn_link: product_pages[Proxy_type.EV_ISP],
      features: ['Global Mobile IPs', 'Advanced Network Routing',
        'Ticket Master/AXS/Retail Sites'],
    },
    {
      icon: <Icon_sneakers />,
      title: 'Sneakers Residential Proxies',
      description: 'Full access to top sneaker sites with no KYC process'
        + ' required!',
      btn_caption: get_price(
        product_cards_data,
        Proxy_type.SNK,
        'Starting at $0.85/IP'),
      btn_link: product_pages[Proxy_type.SNK],
      features: ['Global residential proxies', 'Advanced Network Routing',
        'No KYC needed'],
    },
    {
      icon: <Icon_events_resi />,
      title: 'Events Tickets Residential Proxies',
      description: 'Perfect for securing top spots at events and accessing'
        + ' e-commerce sites seamlessly.',
      btn_caption: get_price(
        product_cards_data,
        Proxy_type.EV_RES,
        'Starting at $0.90/IP'),
      btn_link: product_pages[Proxy_type.EV_RES],
      features: ['Global residential proxies', 'Advanced Network Routing',
        'Quick identity verification process'],
    }
  ];
};

export const Products = (props: i_product_props)=>{
  const {show_free_zone_promo} = use_app_context();
  const {pathname} = useLocation();
  const get_data_id =()=>`schema-products-${pathname}`;
  const {data} = use_data_provider(get_data_id);
  const caption = props.title || 'Our Products';
  const oculus_plans = use_plans();

  const products:i_product[]=React.useMemo(()=>{
    const initial_products_data =
        products_data(show_free_zone_promo, oculus_plans);
    return initial_products_data?.map(result_data=>{
      const detected_product = data?.result?.data
        .find(product_data=>product_data.name === result_data?.title);
      return {
        ...result_data,
        description: detected_product?.description || result_data.description
      };
    });
  }, [data?.result?.data, show_free_zone_promo, oculus_plans]);

  return <div className={styles.products_container}>
    <Dynamic_heading dangerouslySetInnerHTML={{__html: caption}}
      tag={props.title_tag}/>
    <div className={styles.cards_grid}>
      {products.map((product, index)=>
        <Product_card key={index} product={product}
          btn_color={product.show_promo ? 'primary' : 'secondary'}/>
      )}
    </div>
  </div>;
};
